<!--
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-07-18 14:42:13
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-04-20 18:19:49
 * @FilePath: \ioc_base\src\modules\reserve\view\reserveProcessTest.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="reserve-process">
    <!-- 顶部标题栏 -->
    <!-- <div class="top-title">
      <div class="back-btn pointer" @click="returnBack">
        <i class="el-icon-back"></i>
        <span style="margin-left: 5px">返回</span>
      </div>
      <span>处理流程 【 {{ reserveDetail.emergencyPlanName }} 】 </span>
    </div> -->
    <!-- 主内容区 -->
    <div class="process-list">
      <!-- 左侧 -->
      <div class="left-container">
        <!-- 左tab页签 -->
        <div class="left-tab-list">
          <div class="detail-title leftList-title">
            <span>预案流程</span>
            <el-button type="info" @click="handleAddProcess" icon="el-icon-plus">
              添加配置</el-button
            >
            <el-button type="primary" @click="returnBack" icon="el-icon-back">
              返回</el-button
            >
          </div>
          <div class="box-card">
            <el-scrollbar class="scroll-content" style="height: 100%">
              <div
                v-for="(val, ind) in processList"
                :key="ind"
                :class="[
                  'tab_list_content',
                  val.step == stepInfo.step ? 'tabCheck' : 'tab_list_finsh',
                ]"
                @click="stepListDetail(val, ind)"
              >
                <ul>
                  <li class="pro_tab_title">
                    {{ formatterStepName(val.step) }}
                  </li>
                  <li>{{ descList[val.step] }}</li>
                  <li>{{ val.operateTime | formartterTime(val) }}</li>
                </ul>
              </div>
            </el-scrollbar>
          </div>
          <div class="submit-btn">
            <el-button
              type="primary"
              v-auth="'/reserveImplement:update'"
              @click="submitReport"
              >提交报告</el-button
            >
          </div>
        </div>
        <!-- tab内容区-非广播展示区域-->
        <div class="step_main" :class="stepInfo.step == 6 ? 'showMap' : ''">
          <div class="step_title">
            {{ reserveDetail.emergencyPlanName }}
          </div>

          <!-- 步骤名称 -->
          <div class="step_name">{{ stepTitle }}</div>
          <!-- 步骤内容 -->
          <div class="step_middle">
            <!-- 短信通知,任务下发 -->
            <notice-config
              :reserveDetail="reserveDetail"
              ref="noticeConfigNew"
              v-if="stepInfo.step == '1' || stepInfo.step == '4'"
              :key="stepInfo.step"
              @sendFinish="sendLoading = false"
              :stepInfo="stepInfo"
              :handleProcessType="handleProcessType"
            ></notice-config>
            <!-- 现场处置 -->
            <process-control
              ref="processControl"
              :handleAlarmType="handleProcessTypeT"
              :stepType="stepInfo.step"
              v-if="stepInfo.step == '7'"
            ></process-control>
            <!-- 道闸控制 -->
            <gate-control ref="gatepage" v-if="stepInfo.step == '5'"></gate-control>

            <!-- 视频配置 -->
            <keep-alive>
              <div class="step_item" v-show="stepInfo.step == '2'">
                <div class="step_item_check" style="display: flex">
                  <label style="width: 115px; height: 32px; line-height: 32px"
                    >摄像机: (距离/m)
                  </label>
                  <!-- @change="getTreeList" -->
                  <el-radio-group
                    v-model="selectKm"
                    :disabled="cameraList.length > 3"
                    size="mini"
                  >
                    <el-radio-button label="-1" @click.native.prevent="getTreeList(-1)"
                      >全部</el-radio-button
                    >
                    <el-radio-button
                      label="30"
                      @click.native.prevent="getTreeList(30)"
                    ></el-radio-button>
                    <el-radio-button
                      label="50"
                      @click.native.prevent="getTreeList(50)"
                    ></el-radio-button>
                    <el-radio-button
                      label="100"
                      @click.native.prevent="getTreeList(100)"
                    ></el-radio-button>
                    <el-radio-button
                      label="200"
                      @click.native.prevent="getTreeList(200)"
                    ></el-radio-button>
                  </el-radio-group>
                </div>
                <!-- <VideoPlay ref="player" style="height: calc(100% - 0px); color: #fff"></VideoPlay> -->
                <div style="height: calc(100% - 20px)">
                  <DhPlayer
                    ref="dhPlayerPlan"
                    videoId="dhPlayerPlan"
                    :shieldClass="[
                      'el-message',
                      'el-message-box',
                      'el-dialog',
                      'el-picker-panel',
                      'hover-blur-panel',
                      'app-side-panel',
                    ]"
                    :windowType="windowType"
                    :division="division"
                  ></DhPlayer>
                </div>
              </div>
            </keep-alive>
          </div>

          <!-- 步骤按钮 -->
          <div class="operate-btn">
            <el-button
              type="primary"
              v-if="stepInfo.step == '4'"
              style="width: 80px"
              :loading="snapLoading"
              @click="addTaskInfo"
            >
              <!-- 任务下发提交btn -->
              {{ snapLoading ? "提交中" : " 任务通知" }}
            </el-button>
            <el-button
              type="primary"
              v-if="stepInfo.step == '1'"
              style="width: 80px"
              :loading="sendLoading"
              @click="sendMessage"
            >
              <!-- 短信通知btn -->
              {{ sendLoading ? "发送中" : "立即发送" }}
            </el-button>

            <el-button
              type="primary"
              v-if="stepInfo.step == '2'"
              style="width: 80px"
              :loading="snapLoading"
              @click="localSnapAll"
            >
              {{ snapLoading ? "抓拍中" : "一键抓拍" }}
            </el-button>
            <!-- <el-button type="primary" v-if="stepInfo.step == '4'" style="width: 80px" :loading="snapLoading2"
              @click="onOpenNotice">
              {{ snapLoading2 ? "查询中" : "通知回执" }}
            </el-button> -->
          </div>
        </div>
        <!-- 广播--单独引入广播组件 -->
        <div class="broadcastAdd" v-if="stepInfo.step == '6'">
          <broadcastMain @leverCall="mapCall(2)" :alarm="reserveDetail" />
        </div>
      </div>
      <!-- 右侧详情展示 -->
      <div class="right-detail">
        <el-scrollbar style="height: calc(100% - 50px)">
          <!-- 一键求救展示图片 -->
          <div v-if="alarm.subSystem == '12'">
            <img
              class="noImg"
              style="height: 160px; width: 100%"
              src="../images/sos.png"
            />
          </div>
          <!-- 烟花告警图片 -->
          <div v-if="alarm.subSystem == '5'">
            <el-carousel style="height: 120px; overflow: hidden; margin-bottom: 10px">
              <el-carousel-item
                v-for="item in (alarm.alarmSnapUrl || alarm.picUrl || '').split(',')"
                :key="item"
              >
                <img
                  class="lookPhoto"
                  :src="Bus.imgPath(item)"
                  style="width: 100%; height: 120px; cursor: pointer"
                  @click="showViewer"
                  onerror="this.src='/images/theme/newDark/default.png'"
                />
              </el-carousel-item>
            </el-carousel>
          </div>

          <!-- 消防告警  告警基本信息-->
          <div class="detail-title right-title" v-if="alarm.subSystem == '4'">
            告警基本信息
          </div>
          <div class="content-container" v-if="alarm.subSystem == '4'">
            <el-row>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark mb10">
                  告警类型：
                  <span :class="showColor(alarm.commonAlarmType)">{{
                    alarm.commonAlarmTypeLabel
                  }}</span>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark mb10">
                  设备告警类型：
                  <span>{{ alarm.alarmTypeLabel }}</span>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark mb10">
                  告警时间：{{ alarm.alarmTime | moment }}
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark mb10">
                  告警级别：
                  <span :class="alarmColor(alarm.alarmLevel)">
                    {{ alarm.alarmLevel | dic("SENU017") }}
                  </span>
                </div>
              </el-col>
              <el-col :span="24" class="mb10">
                <div
                  class="grid-content bg-purple-dark"
                  style="line-height: 26px"
                  v-if="alarm.desc"
                >
                  告警描述：{{ alarm.desc }}
                </div>
                <div v-else class="grid-content bg-purple-dark">
                  告警描述：
                  <span v-if="alarm.buildingName"
                    >在{{ alarm.buildingName }}位置,{{
                      alarm.subDeviceMark | dic("SENU094")
                    }}上报
                    <span
                      v-if="alarm.commonAlarmType"
                      :class="showColor(alarm.commonAlarmType)"
                      >{{ alarm.commonAlarmTypeLabel }}</span
                    >
                  </span>
                </div>
              </el-col>
            </el-row>
          </div>
          <!-- 告警详情 -->
          <div class="alarm-detail" v-if="alarm.alarmId">
            <!-- 告警详情 -->
            <div class="detail-title right-title">
              {{
                alarm.subSystem == "12"
                  ? "一键求救-"
                  : alarm.subSystem == "5"
                  ? "烟火-"
                  : ""
              }}告警详情
            </div>
            <div
              class="ioc-alarm__drawer__card"
              v-if="alarm.subSystem == '12' || alarm.subSystem == '5'"
            >
              <alarmDetails :detail="alarm"></alarmDetails>
            </div>
            <div class="content-container" v-if="alarm.subSystem == '4'">
              <el-row>
                <el-col :span="24">
                  <div class="grid-content bg-purple-dark mb10">
                    主机类型：{{ alarm.deviceType | dic("SENU087") }}
                    <span
                      v-if="
                        alarm.deviceType || alarm.parentFactoryName || alarm.factoryName
                      "
                      >(</span
                    >
                    {{
                      alarm.subDeviceMark ? alarm.parentFactoryName : alarm.factoryName
                    }}
                    <span
                      v-if="
                        alarm.deviceType || alarm.parentFactoryName || alarm.factoryName
                      "
                      >)</span
                    >
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="grid-content bg-purple-dark mb10">
                    主机名称：{{
                      alarm.subDeviceMark ? alarm.parentDeviceName : alarm.deviceName
                    }}
                    <span
                      v-if="
                        alarm.parentDeviceName ||
                        alarm.deviceName ||
                        alarm.parentThirdAlarmDevId
                      "
                      >(</span
                    >
                    {{ alarm.parentThirdAlarmDevId }}
                    <span
                      v-if="
                        alarm.parentDeviceName ||
                        alarm.deviceName ||
                        alarm.parentThirdAlarmDevId
                      "
                      >)</span
                    >
                  </div>
                </el-col>
                <el-col :span="24" v-if="alarm.subDeviceMark">
                  <div class="grid-content bg-purple-dark mb10">
                    部件名称：{{ alarm.deviceName }}
                    <span v-if="alarm.componentThirdAlarmDevId && alarm.deviceName"
                      >(</span
                    >
                    {{ alarm.componentThirdAlarmDevId }}
                    <span v-if="alarm.componentThirdAlarmDevId && alarm.deviceName"
                      >)</span
                    >
                  </div>
                </el-col>
                <el-col :span="24" v-if="alarm.subDeviceMark">
                  <div class="grid-content bg-purple-dark mb10">
                    部件类型：{{ alarm.subDeviceMark | dic("SENU094") }}
                  </div>
                </el-col>
                <!-- <el-col :span="24" v-if="alarm.subDeviceMark">
                  <div class="grid-content bg-purple-dark mb10">
                    回路：{{ alarm.loopThirdAlarmDevId }}
                  </div>
                </el-col>
                <el-col :span="24" v-if="alarm.subDeviceMark">
                  <div class="grid-content bg-purple-dark mb10">
                    分机号：{{ alarm.childThirdAlarmDevId }}
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="grid-content bg-purple-dark mb10">
                    IP地址：{{
                      alarm.subDeviceMark ? alarm.parentIp : alarm.ip
                    }}
                  </div>
                </el-col> -->
                <el-col :span="24">
                  <div class="grid-content bg-purple-dark mb10">
                    报警所在位置：{{ alarm.buildingName }}
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="detail-title right-title">应急卡信息</div>
            <el-table :data="emergencyCardList" style="width: 100%">
              <el-table-column prop="cardName" label="处置卡" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="deviceName" label="设备" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="fileCode" label="文件">
                <template slot-scope="scope">
                  <img
                    :src="Bus.imgPath(scope.row.fileCode)"
                    @click="handleView"
                    onerror="this.src='/images/theme/newDark/default.png'"
                    style="height: 25px; width: 50px; cursor: pointer"
                  />
                </template>
              </el-table-column>
              <el-table-column prop="desc" label="描述" show-overflow-tooltip>
              </el-table-column>
            </el-table>
          </div>

          <div class="alarm-detail" v-else>
            <div class="detail-title right-title">预案描述</div>
            <ul class="alarm-info">
              <li>{{ reserveDetail.desc }}</li>
            </ul>
          </div>
        </el-scrollbar>
        <div
          class="submit-btn"
          v-if="reserveDetail.alarmId && reserveDetail.processStatus != 1"
        >
          <el-button type="primary" @click="handleDeal">处理</el-button>
        </div>
      </div>
    </div>

    <!-- 增加预案流程 弹框 -->
    <el-dialog
      ref="addStep"
      title="动作内容"
      :visible.sync="isAddShow"
      @close="isAddShow = false"
      width="560px"
    >
      <IocTransfer
        :value.sync="rightCheckedStep"
        :props="propStep"
        @addStep="addStep"
        @changeData="checkStep"
        ref="ioctrioctransfer2"
        type="step"
        :data="stepAll"
        :titles="['执行动作', '已选动作']"
      ></IocTransfer>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isAddShow = false">{{
          dialogAdd ? "提交中" : "取 消"
        }}</el-button>
        <el-button type="primary" :loading="dialogAdd" @click="handleSaveProcess">{{
          dialogAdd ? "提交中" : "保 存"
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 区域树 -->
    <el-dialog title="摄像机列表" :visible.sync="showTreeList" width="550px">
      <div style="height: 400px">
        <!-- @deviceChoose="chooseDevice" -->
        <app-camers-group
          ref="deviceTree"
          :multiCheck="true"
          @cameraData="chooseDevice"
          style="position: inherit"
        >
        </app-camers-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog">取 消</el-button>
        <el-button type="primary" @click="submitDialog">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 弹出提交报告 -->
    <reserve-record-details
      ref="record"
      :title="title"
      :textarea="textarea"
      :activeName="activeName"
      :reportDetails="reportDetails"
      :stepList="stepList"
      :btn="true"
      @submitData="submitData"
      @showStepDetails="getDetailsList"
    >
    </reserve-record-details>
    <!-- 执行详情列表 -->
    <el-dialog
      :visible.sync="showStepDetails"
      title="执行详情"
      v-dialogDrag
      @close="closeStepDetail"
    >
      <ioc-table
        style="height: 400px"
        :data="stepHistoryList"
        :option="stepOptionList"
        :page="pageDetails"
        @size-change="sizeChangeDetails"
        @current-change="pageChangeDetails"
      >
        <template slot="图片" slot-scope="scope">
          <img
            :src="scope.row.图片"
            @click="showViewer($event)"
            onerror="this.src='/images/theme/newDark/default.png'"
            style="height: 25px; width: 50px; cursor: pointer"
          />
        </template>
      </ioc-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showStepDetails = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 通知回执 -->
    <el-dialog
      title="回执详情"
      :visible.sync="noticeDialog"
      destroy-on-close
      width="750px"
      :close-on-click-modal="false"
    >
      <div>
        <el-radio-group v-model="noticeType" @change="onChangeNoticeType">
          <el-radio-button label="4">鲁南云APP阅读</el-radio-button>
          <el-radio-button label="5">安保APP阅读</el-radio-button>
        </el-radio-group>
      </div>
      <ioc-table
        :data="noticeData"
        v-loading="tableLoading"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
        :option="noticeTableOption"
        :page="noticePage"
        style="height: 400px"
        @size-change="noticeChangeSize"
        @current-change="noticeCurrentChange"
      >
      </ioc-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="noticeDialog = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
//引入字典
import { Dates, Dic, Bus } from "$utils";
//引入接口API
import { api } from "../api";
import utils from "@src/common/utils";
// import VideoPlay from "../components/video-play.vue";
import DhPlayer from "@/components/business/dh-player/index.vue";
import IocTransfer from "../components/step-transfer";
import appCamersGroup from "../components/areaListTree";
import reserveRecordDetails from "../../reserveRecord/view/reserveRecordDetails";
import stepOption from "../../reserveRecord/const/step";
import gateControl from "../components/gateControl";
import processControl from "../components/process-control";
import broadcastMain from "../components/broadcastNew";
import noticeConfig from "../components/noticeConfigNew";
import tableOption from "../const/noticeTableOption";
import mixinFlv from "@src/components/common/media-player/mixinFlv";
import alarmDetails from "@src/modules/reserveImplement/components/alarmDetail";
export default {
  mixins: [mixinFlv],
  name: "reserve-process",
  filters: {
    formartterTime(time) {
      return time ? Dates.dayjs(Number(time)).format("YYYY-MM-DD HH:mm:ss") : "";
    },
    showType(alarmType, item) {
      return Dic.findByValue(`SENU00400${alarmType[0]}`, alarmType);
    },
  },
  components: {
    broadcastMain,
    // VideoPlay,
    DhPlayer,
    IocTransfer,
    appCamersGroup,
    reserveRecordDetails,
    gateControl,
    noticeConfig,
    processControl,
    alarmDetails,
  },
  data() {
    return {
      tableLoading: false,
      indexNum: 0,
      Bus,
      noticeReceiptId: "",
      noticeType: "4",
      noticePage: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      noticeTableOption: tableOption(),
      noticeData: [],
      emergencyCardList: [],
      handleProcessSimpleShow: false,
      handleProcessShow: false,
      isShow: false,
      handleProcessTypeT: "",
      //告警类型
      handleProcessType: "",
      handleProcessList: [],
      searchFormShow: false,
      handleProcessFile: "",
      simpleProcessFile: "",
      formDialog: {
        newLever: "",
      },
      url: "",
      // 处置流程
      handleProcessBase64: "",
      // 简化流程
      simpleProcessBase64: "",
      paramsData: {},
      pageDetails: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      textarea: "",
      reportDetails: [],
      stepList: [],
      activeName: "first",
      title: "报告详情",
      showStepDetails: false,
      showDetails: false,
      stepHistoryList: [],
      stepOptionList: [],
      tabPosition: "left",
      processList: [],
      descList: [
        "",
        "对周边人员进行操作",
        "信息通知",
        "对图片抓拍",
        "任务通知",
        "道闸控制",
        "对周边设备操作",
        "指导现场执行",
      ],
      level: "Ⅰ",
      ocx: {
        x: 1000,
        y: 400,
      },
      isAddShow: false,
      rightCheckedStep: [],
      propStep: {
        label: "label",
        key: "value",
      },
      stepAll: [],
      stepTitle: "任务下发",
      btnMsg: "立即下发",
      playDeviceData: [],
      playTime: "",
      isVideos: false,
      areaName: "",
      showTreeList: false,
      isFullScreen: false,
      selectedPerson: [],
      planStepCodeNow: "",
      emergencyProcessIDNow: "",
      emergencyRecordCode: "",
      reserveDetail: {},
      alarm: {},
      processNames: "",
      processName: [],
      checkedAccounts: [], //短信列表勾选人员
      sortNow: 0,
      taskDesc: "",
      showLevel: false,
      leverList: [],
      dialogAdd: false,
      // 配置步骤详情
      stepInfo: {},
      playerLoading: false,
      selectKm: "",
      Kmlist: [],
      cameraListbf: [],
      cameraList: [],
      checkCameraList: [],
      snapLoading: false,
      sendLoading: false,
      noticeDialog: false,
      snapLoading2: false,
      snapShowId: "",
      // dh视频插件
      // 播放类型
      windowType: 0,
      // 分割窗格
      division: 4,
      // 当前窗口
      currentNum: 0,
      fireDefaultCamera: [],
      firstIp: "",
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
  },
  created() {
    // busVue.$on("localSnapVideo", (info) => {
    //   this.showViewer(info);
    // });
    let hostName = location.hostname;
    let ipIndex = hostName.indexOf(".");
    if (ipIndex !== -1) {
      this.firstIp = hostName.substring(0, ipIndex);
    }
  },
  mounted() {
    // 地图初始化
    this.mapCall();
  },
  beforeDestroy() {
    this.$refs.dhPlayerPlan.closeVideo();
    this.$refs.dhPlayerPlan.destroy();
    this.$map.hideMap2D();
    // busVue.$off("localSnapVideo");
  },
  methods: {
    handleView(e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    // 地图初始化,用于地图后完成资源展示
    mapCall(type) {
      if (type) {
        this.$map.showMap2D(() => {
          this.$map.MapInstance2D.setMapZoom(18);
        });
        return;
      }
      this.$map.showMap2D(this.initPage);
    },
    // 页面数据初始化
    initPage() {
      this.stepAll = Dic.find("SENU073006");
      this.leverList = Dic.find("SENU073002");
      this.Kmlist = Dic.find("SENU073008");
      if (this.$route && this.$route.query) {
        this.emergencyRecordCode = this.$route.query.emergencyRecordCode;
      }
      this.selectKm = this.Kmlist[0].value;
      this.queryRecordDetail(); //获取预案详情
    },
    // 步骤名称格式化
    formatterStepName(value) {
      return Dic.findByValue("SENU073006", value);
    },
    // 查询预案详情
    queryRecordDetail(isplay = true) {
      this.$fetch(api.reserve.queryRecordDetail, {
        emergencyRecordCode: this.emergencyRecordCode,
      }).then((res) => {
        if (res.success) {
          this.$store.state.common.reserveDetail = res.returnObj;
          this.reserveDetail = res.returnObj;
          this.emergencyRecordCode = this.reserveDetail.emergencyRecordCode;
          this.processList = [...this.reserveDetail.emergencyRecordStepList];
          this.planStepCodeNow = this.processList[0].planStepCode;
          this.rightCheckedStep = this.processList.map((item) => parseInt(item.step));
          this.handleProcessType = res.returnObj.subSystem;
          // 如果是告警,获取告警详情
          if (this.reserveDetail.alarmId) {
            this.getAlarmDetail();
          }
          res.returnObj.emergencyCardList
            ? (this.emergencyCardList = res.returnObj.emergencyCardList.filter((s) => {
                return s;
              }))
            : (this.emergencyCardList = []);
          this.handleProcessTypeT = res.returnObj.subSystem;
          //   默认显示第一个步骤
          this.stepListDetail(this.processList[0]);
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 获取告警level
    getAlarmDetail() {
      const params = {
        alarmId: this.reserveDetail.alarmId,
      };
      this.$fetch(api.reserve.getAlarmDetail, params).then((response) => {
        if (response && response.success) {
          if (response.returnObj) {
            this.alarm = response.returnObj;
          }
        }
      });
    },
    // 查询步骤详情
    stepListDetail(item) {
      this.stepInfo = item; //保存数据
      this.snapShowId = "";
      console.log("左侧步骤详情", item);
      this.emergencyProcessIDNow = item.emergencyRecordCode;
      this.stepTitle = this.formatterStepName(item.step);
      if (item.step == 2) {
        // 视频调度
        if (this.indexNum == 0) {
          this.indexNum += 1;
          // 如果时预案通知，需要调默认的视频配置,
          this.getDefaultVideo();
        }
      }
      if (item.step == 4 || item.step == 1) {
        // 任务分发,短信通知
        this.queryEmergencyGroup();
      }
    },
    // 查询短信通知选中的应急组回显
    queryEmergencyGroup() {
      this.$fetch(api.reserveProcess.queryEmergencyGroup, {
        emergencyRecordCode: this.emergencyRecordCode,
      }).then((response) => {
        if (response && response.success) {
          let rightList = response.returnObj.integratedGroupCodeList || [];
          let leftList = response.returnObj.workShopGroupCodeList || [];
          this.$nextTick(() => {
            if (!rightList.length && !leftList.length) {
              //
            } else {
              this.$refs.noticeConfigNew.checkedKeysLeft = leftList;
              this.$refs.noticeConfigNew.checkedKeysRight = rightList;
            }
            this.$refs.noticeConfigNew.getTreeData();
          });
        } else {
          response.msgContent && this.$message.error(response.msgContent);
        }
      });
    },
    // 左侧提交报告
    submitReport() {
      this.activeName = "first";
      // this.showDetails = true
      this.textarea = this.reserveDetail.desc;
      this.$refs["record"].showDetails = true;
      this.$fetch(api.reserve.getRecordDetail, {
        emergencyRecordCode: this.emergencyRecordCode,
      }).then((res) => {
        if (res.success) {
          if (!res.returnObj) {
            this.$message.warning("暂无数据，稍后再试");
            return;
          }
          this.stepList = res.returnObj.emergencySubRecordList;
          this.reportDetails = res.returnObj.snapshotFileCodeList;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    handleDeal() {
      let param = {
        emergencyRecordCode: this.emergencyRecordCode,
        processDesc: "",
        processStatus: "1",
      };
      this.$fetch(api.reserve.processEmergencyAlarm, param).then((res) => {
        if (res.success) {
          this.$message.success("操作成功");
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 弹窗提交报告
    submitData(data) {
      let params = {
        emergencyRecordCode: this.processList[0].emergencyRecordCode,
        reportDesc: data,
      };
      this.$fetch(api.reserve.addEmergencyReport, params).then((response) => {
        if (response && response.success) {
          this.$message.success(response.msgContent);
          this.$refs["record"].showDetails = false;
          this.$router.push({ path: "/reserveImplement" });
        } else {
          response.msgContent && this.$message.error(response.msgContent);
        }
      });
    },
    // 关闭报告详情
    closeStepDetail() {
      this.stepOptionList = stepOption([]);
      this.stepHistoryList = [];
    },
    // 获取报告详情
    getDetailsList(ary, data, url, params, dataAll) {
      this.stepHistoryList = data ? data : []; //数据显示
      this.stepOptionList = stepOption(ary); //配置项
      this.showStepDetails = true;
    },
    // 详情数据分页
    sizeChangeDetails(pageSize) {
      this.$fetch(this.url, {
        pageNum: this.pageDetails.currentPage,
        pageSize: pageSize,
        emergencyProcessID: this.paramsData.emergencyProcessID,
      }).then((res) => {
        this.pageDetails.total = res.returnObj.total;
        this.stepHistoryList = res.returnObj.list;
      });
    },
    // 详情数据分页
    pageChangeDetails(pageNo) {
      this.$fetch(this.url, {
        pageNum: pageNo,
        pageSize: this.pageDetails.pageSize,
        emergencyProcessID: this.paramsData.emergencyProcessID,
      }).then((res) => {
        this.pageDetails.total = res.returnObj.total;
        this.stepHistoryList = res.returnObj.list;
      });
    },

    // 根据回执类型查详情
    onChangeNoticeType(val) {
      this.noticePage.pageNum = 1;
      this.noticePage.pageSize = 10;
      this.getNoticeDetail();
    },
    noticeChangeSize(val) {
      this.noticePage.pageNum = 1;
      this.noticePage.pageSize = val;
      this.getNoticeDetail();
    },
    noticeCurrentChange(val) {
      this.noticePage.pageNum = val;
      this.getNoticeDetail();
    },
    // 获取回执详情接口
    getNoticeDetail() {
      this.noticeTableOption.column[this.noticeTableOption.column.length - 1].hide =
        this.noticeType == 5 ? true : false;
      this.noticeTableOption.column[3].hide = this.noticeType == 5 ? true : false;
      this.tableLoading = true;
      this.$fetch(api.queryNotifyRecordByPage, {
        pageNum: this.noticePage.pageNum,
        pageSize: this.noticePage.pageSize,
        emergencySubRecordCode: this.noticeReceiptId || "", //"20211217001027"
        notifyType: this.noticeType,
        emergencyRecordCode: this.emergencyRecordCode,
      }).then((res) => {
        this.tableLoading = false;
        if (res && res.success) {
          this.noticeData = res.returnObj.list;
          this.noticePage.total = res.returnObj ? res.returnObj.total : 0;
        } else {
          res.msgContent && this.$message.error(res.msgContent);
        }
      });
    },
    // 打开通知回执
    onOpenNotice() {
      this.getNoticeDetail();
      this.noticeDialog = true;
    },
    // TODO短信通知及信息通知立即发送按钮事件
    sendMessage() {
      this.sendLoading = true;
      this.$refs.noticeConfigNew.saveData();
    },
    // 新任务下发接口
    addTaskInfo() {
      // console.log(this.ste)
      if (
        this.$refs.noticeConfigNew.tableData.length === 0 &&
        this.stepInfo.step == "4"
      ) {
        this.$message.warning("请选择应急组下的人员后下发任务");
        return;
      }
      let task = {
        accountInfoList: this.$refs.noticeConfigNew.tableData.map((el) => {
          return {
            name: el.name,
            personOrAccountCode:
              el.personOrAccountType == 2 ? el.workNo : el.personOrAccountCode,
            personOrAccountType: el.personOrAccountType,
            phone: el.phone,
          };
        }),
        code: "",
        desc: "",
        deviceId: "",
        emergencyRecordCode: this.emergencyProcessIDNow,
        emergencySubRecordCode: this.snapShowId,
        // executor: [""],
        // executorName: [""],
        fileInfos: [],
        groupCode: this.alarm.groupCode,
        handleProcessCode: "",
        noticeTemplateCode: this.$refs.noticeConfigNew.templateList[0].noticeTemplateCode,
        notifyContent: this.$refs.noticeConfigNew.templateList[0].templateContent,
        notifyMode: this.$refs.noticeConfigNew.templateList[0].templateType,
        requiredFinishedTime: "",
        requiredStartTime: Dates.format(new Date()),
        status: 2,
        taskAlarmWeb: {
          alarmDevId: this.alarm.alarmDevId,
          alarmId: this.alarm.alarmId,
          alarmLevel: this.alarm.alarmLevel ? this.alarm.alarmLevel : "",
          alarmTime: this.alarm.alarmTime,
          alarmType: this.alarm.alarmType,
          deviceName: this.alarm.deviceName,
          subSystem: this.alarm.subSystem,
        },
        taskName: "",
        taskPriority: "",
        taskType: 1,
        taskVisibility: 2,
        userFrom: "0",
        deviceIdList: [],
      };

      // for (let key in this.$refs.player.deviceRecord) {
      //   let removeKey = key;
      //   task.deviceIdList.push(
      //     this.$refs.player.deviceRecord[removeKey].thirdCameraId
      //   );
      // }

      const playingCamera = this.fireDefaultCamera.concat(this.checkCameraList);

      for (let i = 0; i < playingCamera.length; i++) {
        task.deviceIdList.push(playingCamera[i].thirdCameraId);
      }

      if (this.alarm.alarmLevel) {
        let taskName = this.alarm.alarmName ? this.alarm.alarmName + "-" : "";
        let DicType = this.alarm.alarmType[0] !== "6" ? "SENU004005" : "SENU004006";
        task.taskName = taskName;
        task.taskPriority = this.alarm.alarmLevel;
      } else {
        task.taskName = "手动预案";
        task.taskPriority = "1";
      }
      this.$fetch(api.reserveProcess.addEmergencyInfo, task).then((response) => {
        if (response && response.success) {
          this.snapShowId = "";
          this.noticeReceiptId = response.returnObj;
          this.$message.success(this.$t("realTimeAlarm.message.issueSuc"));
        } else {
          this.$message.warning(response.msgContent);
        }
      });
    },
    // 更新预案执行步骤
    handleSaveProcess() {
      this.dialogAdd = true;
      let params = [];
      if (this.checkStepList) {
        this.checkStepList.map((item, ind) => {
          params.push(item.value);
        });
      } else {
        params = this.rightCheckedStep;
      }
      this.$fetch(api.reserve.updateProcessRecord, {
        emergencyRecordCode: this.emergencyRecordCode,
        stepList: params,
      }).then((res) => {
        setTimeout(() => {
          this.dialogAdd = false;
        }, 1000);
        if (res.success) {
          this.$message.success(res.msgContent);
          this.queryRecordDetail(false);
          this.isAddShow = false;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 预案动作选择回调
    checkStep(val) {
      this.checkStepList = val;
    },
    // 添加预案动作
    addStep(val) {
      let params = {
        planStepName: val,
      };
      this.$fetch(api.reserve.addPlanStep, params)
        .then((response) => {
          if (response.success) {
            this.$message({
              message: response.msgContent,
              type: "success",
            });
            this.$refs.ioctransfer2.addStepBool = false;
            this.queryRecordDetail();
          } else {
            this.$message({
              type: "warning",
              message: response.msgContent,
            });
          }
        })
        .catch(() => {});
    },
    //添加预案配置
    handleAddProcess() {
      this.isAddShow = true;
      this.rightCheckedStep = this.processList.map((item) => parseInt(item.step));
    },
    // 查询摄像机tree
    getTreeList(type) {
      if (this.cameraList.length > 3) {
        return;
      }
      this.showTreeList = true;
      this.selectKm = type;
      this.$nextTick(() => {
        this.$refs.deviceTree.queryDevice({
          distance: type || this.selectKm,
          emergencyRecordCode: this.emergencyRecordCode,
        });
      });
    },
    //选中摄像机回调
    chooseDevice(val, data) {
      // val 摄像机  data 区域
      if (data.length > 0) {
        this.$refs.deviceTree.$refs.appDeviceGroupTree.setCheckedKeys([]);
        if (val.length > 0) {
          let idData = val.map((el) => {
            return el.id;
          });
          this.$refs.deviceTree.$refs.appDeviceGroupTree.setCheckedKeys(idData);
        }
      }
      if (val.length > 0) {
        this.cameraListbf = [];
        val.map((el) => {
          if (el.deviceMark == 18 && el.nodeType == "device") {
            this.cameraListbf.push(el);
          }
        });
        // this.cameraListbf = val
        console.log(this.cameraListbf);
      }
    },
    // 取消选择摄像机
    cancelDialog() {
      this.$refs.deviceTree.$refs.appDeviceGroupTree.setCheckedKeys([]);
      this.cameraListbf = [];
      this.showTreeList = false;
    },
    uploadImg() {},
    // 调用插件抓拍
    localSnapAll() {
      let fileList = [];
      const playingCamera = this.fireDefaultCamera.concat(this.checkCameraList);
      if (playingCamera.length > 0) {
        for (let i = 0; i < playingCamera.length; i++) {
          let url = "/bas/event/dahua/snap/image/" + playingCamera[i].thirdCameraId;
          this.$fetchGet(url).then((response) => {
            if (response.success) {
              fileList.push({
                deviceId: playingCamera[i].thirdCameraId,
                fileCode: response.returnObj,
              });
              this.$nextTick(() => {
                this.handleSnapAllUp({
                  deviceIdList: [playingCamera[i].thirdCameraId],
                  localSnapList: fileList,
                  emergencyRecordCode: this.emergencyRecordCode,
                });
              });
            } else {
              this.$message.error(response.msgContent);
            }
          });
        }
      } else {
        this.$message.warning("暂无播放设备，无法抓拍");
      }
      // let deviceList = this.$refs.player.deviceRecord;
      // let keyList = Object.keys(deviceList);
      // if (!deviceList || keyList.length == 0) {
      //   this.$message.warning("暂无播放设备，无法抓拍");
      //   return;
      // }
      // let fileList = []
      // keyList.forEach((key, index) => {
      //   imosSdk.playCatch(this.$refs.player.playRecord[key].id, (result) => {
      //     console.log("抓拍图片", result);
      //     if (result.ErrCode == 0) {
      //       let formData = new FormData();
      //       let file = this.convertBase64UrlToBlob(result.Img);
      //       formData.append("files", file, new Date().getTime() + ".jpg");
      //       this.$fetch("/common/file/batchFileload.json", formData).then(
      //         (res) => {
      //           if (res.success) {
      //             fileList.push({
      //               deviceId: deviceList[key].thirdCameraId,
      //               fileCode: res.returnObj[0].fileId,
      //             });
      //             this.$nextTick(() => {
      //               if (index == keyList.length - 1) {
      //                 this.snapLoading = true;
      //                 this.handleSnapAllUp({
      //                   localSnapList: fileList,
      //                   emergencyRecordCode: this.emergencyRecordCode,
      //                 });
      //               }
      //             });
      //           }
      //         }
      //       );
      //     }
      //   });
      // });
    },
    // 抓拍上传服务器
    handleSnapAllUp(snapList) {
      this.$fetch(this.$api.common.video.localSnapList, snapList).then((res) => {
        this.snapLoading = false;
        if (!res.success) {
          this.$message.error(res.msgContent);
        } else {
          this.$message({
            message: "抓拍成功",
            type: "success",
          });
        }
      });
    },
    convertBase64UrlToBlob(urlData) {
      var bytes = window.atob(urlData.split(",")[1]); //去掉url的头，并转换为byte
      //处理异常,将ascii码小于0的转换为大于0
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      // var blob = new Blob([ab], {type: 'image/jpeg'}); //type为图片的格式
      return new Blob([ab], { type: "image/png" });
    },
    // 确定摄像机
    submitDialog() {
      this.fireDefaultCamera = [];
      this.checkCameraList = [...this.cameraListbf];
      this.currentNum = 0;
      this.division = this.checkCameraList.length;
      this.cancelDialog();
      if (this.checkCameraList.length > 0) {
        this.checkCameraList.forEach((el, index) => {
          setTimeout(() => {
            // this.$refs.player.handlePlayLive(el);
            this.queryVideoRtsp(el);
          }, 200);
        });
      } else {
        this.$message.warning("该组下暂无摄像机,请重新选择");
      }
    },
    // 获取直播url并播放
    queryVideoRtsp(option) {
      const param = {
        deviceIdList: [option.thirdCameraId],
        protocol: "rtsp",
      };
      this.$fetch(api.queryRealTimeVideoRtsp, param).then((res) => {
        if (res.success) {
          let inNetUrl = res.returnObj[0].url.substring(
            0,
            res.returnObj[0].url.indexOf("|")
          );
          let outNetUrl = res.returnObj[0].url.substr(
            res.returnObj[0].url.indexOf("|") + 1,
            res.returnObj[0].url.length
          );
          // console.log('内网', inNetUrl)
          // console.log('外网', outNetUrl)
          let rtspUrl = "";
          if (this.firstIp == "10" || this.firstIp == "172" || this.firstIp == "192") {
            rtspUrl = inNetUrl;
          } else {
            rtspUrl = outNetUrl;
          }
          let rtspObj = {
            channelId: res.returnObj[0].deviceId,
            path: rtspUrl,
            cameraType: res.returnObj[0].cameraType,
          };
          this.realByUrl(rtspObj);
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 通过rtsp流播放实时预览
    realByUrl(deviceInfo) {
      let param = {
        channelId: deviceInfo.channelId, // 通道ID,必传
        path: deviceInfo.path, // 流地址
        redirect: false, // 9090端口为true   9100端口为false 必传
        cameraType: deviceInfo.cameraType,
      };
      // console.log(param, '播放参数')
      this.$refs.dhPlayerPlan.realByUrl(param, this.currentNum); // 播放的窗口序号 (从0开始计数，表示第一个窗口)
      this.currentNum = this.currentNum + 1;
    },
    stopAll() {
      this.cameraList = [];
      // this.$refs.player.closeAllVideo();
      this.$refs.dhPlayerPlan.closeVideo();
    },
    // 查询默认视频配置
    getDefaultVideo() {
      this.fireDefaultCamera = [];
      if (this.reserveDetail.alarmType == "50107") {
        this.currentNum = 0;
        this.division = 1;
        // this.$refs.player.handlePlayLive({
        //   thirdCameraId: this.reserveDetail.thirdAlarmDevId,
        //   name: this.reserveDetail.deviceName,
        // });
        this.queryVideoRtsp({
          thirdCameraId: this.reserveDetail.thirdAlarmDevId,
          name: this.reserveDetail.deviceName,
        });
        this.fireDefaultCamera = [
          {
            thirdCameraId: this.reserveDetail.thirdAlarmDevId,
            name: this.reserveDetail.deviceName,
          },
        ];
        return;
      }
      this.$fetch(api.reserveProcess.getDeviceVideo, {
        deviceId: this.reserveDetail.alarmDevId,
        cameraConfigFlag: "0",
      }).then((res) => {
        if (res && res.success) {
          let deviceList = res.returnObj;
          this.fireDefaultCamera = deviceList;
          this.currentNum = 0;
          this.division = deviceList.length;
          deviceList.forEach((item) => {
            setTimeout(() => {
              // this.$refs.player.handlePlayLive(item);
              this.queryVideoRtsp(item);
            }, 200);
          });
          // this.cameraList = res.returnObj.filter((el, index) => {
          //   return index < 4;
          // });
          // if (deviceList.length) {
          //   console.log(deviceList);
          //   deviceList.forEach((el, index) => {
          //     if (el.thirdCameraId) {
          //       if (index < this.windowNumber) {
          //         this.$nextTick(() => {
          //           this.$refs.player.playLiveVideo(
          //             Object.assign({ isCover: true }, el),
          //             index + 1
          //           );
          //         });
          //       }
          //     }
          //   });
          // }
        }
      });
    },
    // 批量抓拍成功回调
    // localSnapCall(data) {
    //   console.log(data);
    //   this.snapLoading = false;
    //   this.viewerPhotos = data.map((el) => {
    //     return el.img_url;
    //   });
    //   this.viewerInstance.show(); //destroy()
    //   document
    //     .querySelector(".viewer-transition")
    //     .classList.add("viewer-reserve");
    //   this.snapShowId = data[0].emergencySubRecordCode;
    // },
    showViewer(e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    showColor(val) {
      if (val == "4001") {
        return "colorRed";
      } else if (val == "4002") {
        return "colorYellow";
      } else if (val == "4005" || val == "4008" || val == "4009" || val == "40099") {
        return "colorBlue";
      } else if (val == "130103") {
        return "colorYellow";
      } else if (val == "130101") {
        return "colorRed";
      } else {
        return "";
      }
    },
    alarmColor(level) {
      let className = "";
      if (level === 1) {
        className = "instancys";
      }
      if (level === 2) {
        className = "severitys";
      }
      if (level === 3) {
        className = "generals";
      }
      if (level === 4) {
        className = "commons";
      }
      return className;
    },
    // 返回预案中心
    returnBack() {
      this.$router.push({
        path: "/reserveImplement",
        query: { emergencyRecordCode: this.emergencyRecordCode },
      });
    },
  },
};
</script>
<style>
.viewer-reserve {
  height: calc(100% - 50px);
}
</style>
<style lang="scss" scoped>
@import "../style/reserveProcess.scss";
.reserve-process {
  margin: 12px 16px 0 16px;
}

.broadcastAdd {
  width: calc(100% - 362px);
  position: relative;
}

.tabCheck {
  color: #fff;
  background: linear-gradient(91deg, #3e76e6 0%, rgba(62, 118, 229, 0) 100%);
  // @include set_theme_color(background-color, main-theme-color);
}

.wnNum {
  height: 2px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.player-box {
  width: 100%;
  height: 100%;
  background: #3a3a3a url("/images/theme/newDark/default.png") center no-repeat;
  border: rgba(#000, 0.5) solid 2px;
  position: relative;

  &__loading {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgba($color: #000, $alpha: 0.4);
  }
}

.content-container {
  background: rgba(255, 255, 255, 0.65);
  padding: 5px;
}

.ioc-alarm__drawer__card {
  background: rgba(28, 31, 39, 0.5);
}
</style>
